import { ConvertibleAction } from 'types/ConvertibleAction'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import { ActionFormWithId } from '../../pages/admin/convertibles/edit-convertible/ActionForm'
import i18n from 'i18next'

export const getConvertibleLoanAmount = (convertible: ConvertibleEntity) => {
    if (!convertible.convertibleActions || convertible.convertibleActions.length === 0) return null

    return convertible.convertibleActions.reduce((acc: number, action: ConvertibleAction | ActionFormWithId) => {
        if (action.actionType === 'new_loan' && action.loanAmount !== null) {
            acc += action.loanAmount
        }
        return acc
    }, 0)
}

export const getConvertibleNoncashConsiderationLabel = (
    convertible: Pick<ConvertibleEntity, 'noncashConsideration' | 'linkedIssues'>,
): string | null => {
    if (convertible.noncashConsideration) {
        return convertible.noncashConsideration
    }

    return null
}

export const getConvertibleStatusLabel = (convertible: ConvertibleEntity) => {
    if (convertible.completed) {
        return i18n.t('pages.convertibles.status.repaid')
    }

    const loanAmount = getConvertibleLoanAmount(convertible)
    if (convertible.creditLine !== null && (loanAmount === null || loanAmount === 0)) {
        return i18n.t('pages.convertibles.status.unusedCreditLine')
    }

    return i18n.t('pages.convertibles.status.outstandingLoan')
}
